import { render, staticRenderFns } from "./Empilhadeiras.vue?vue&type=template&id=79e083a6&"
import script from "./Empilhadeiras.vue?vue&type=script&lang=js&"
export * from "./Empilhadeiras.vue?vue&type=script&lang=js&"
import style0 from "./Empilhadeiras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports